import { makeStyles } from '@material-ui/styles';
import { Dropdown, Theme } from '@bizzabo/design-system';
import TriggerActionsMenu from '../CustomMessage/Actions/TriggerActionsMenu';
import UnbanUserAction from './UnbanUserAction';
import useTypeTracking from '../../analytics';

interface UnbanUserActionsProps {
    userId: string;
    unBanUserTriggered: (userId: string) => void;
}

const UnbanUserActions: React.FC<UnbanUserActionsProps> = ({ unBanUserTriggered, userId }) => {
    const classes = useStyles();
    const { trackClickEvent } = useTypeTracking();
    return (
        <Dropdown
            placement="left-start"
            button={({ isOpen }) => <TriggerActionsMenu isOpen={isOpen} />}
            onOpen={() => {
                trackClickEvent({
                    buttonType: 'UNBAN_USER_CLICK_MENU',
                    subCategory: 'OPEN_MENU',
                });
            }}
        >
            {(closeDropdown: () => void) => (
                <div className={classes.container}>
                    <UnbanUserAction
                        onUnBanClicked={() => {
                            unBanUserTriggered(userId);
                            closeDropdown();
                        }}
                    />
                </div>
            )}
        </Dropdown>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        container: {
            display: 'flex',
            'flex-direction': 'column',
            'align-items': 'flex-start',
            padding: '16px 16px 16px 12px',
            'box-shadow': '0px 4px 14px rgba(0, 0, 0, 0.1)',
            'border-radius': 12,
            width: 180,
            background: theme.palette.greys['100'],
        },
    }),
    {
        classNamePrefix: 'UnbanUserActions',
    }
);

export default UnbanUserActions;
